import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import BryxDialog from "./BryxDialog";
import BryxButton from "../BryxButton";
const BryxConfirmationDialog = styled((props) => {
    function handleNegativeResponse() {
        if (typeof props.setOpen != "undefined")
            props.setOpen(false);
        props.onAction(false);
    }
    function handlePositiveResponse() {
        if (typeof props.setOpen != "undefined")
            props.setOpen(false);
        props.onAction(true);
    }
    return (_jsx(BryxDialog, { open: props.open, title: props.title, content: _jsx("span", { children: props.message }), actions: _jsxs(_Fragment, { children: [_jsx(BryxButton, { variant: "outlined", onClick: handleNegativeResponse, children: props.negativeActionLabel || "Cancel" }), _jsx(BryxButton, { variant: "contained", onClick: handlePositiveResponse, children: props.positiveActionLabel || "Confirm" })] }) }));
})(({ theme: _ }) => {
    // theme stub-- currently a no-op but left in place in the even that future styling is required
    return {
        "& *": {
            fontFamily: "Open Sans",
        },
    };
});
export default BryxConfirmationDialog;
